import { RenderState } from '../../../../types/RenderState.type';
import { replaceParam } from 'url-params-helper';
import { cancelable } from 'cancelable-promise';
import { TRANSPARENT_IMAGE_SRC } from '../../../../constants/Constants';
export class PdfThumbnailViewerPageComponent {
    constructor(hostElement, url = null, maxDimensions, pageNumber = null, pdfJsService) {
        this.hostElement = hostElement;
        this.url = url;
        this.maxDimensions = maxDimensions;
        this.pageNumber = pageNumber;
        this.pdfJsService = pdfJsService;
        this.dimensions = null;
        this.renderState = RenderState.Initial;
        this.image = new Image();
        this.element = document.createElement('div');
        this.element.classList.add('sp-pdf-thumbnail-viewer-page');
    }
    render() {
        this.renderState = RenderState.Running;
        this.hostElement.appendChild(this.element);
        return this.renderImage()
            .then(() => {
            this.renderState = RenderState.Finished;
        }, () => this.renderPdfCanvas())
            .then(() => {
            this.renderState = RenderState.Finished;
        }, () => {
            this.renderState = RenderState.Failed;
        });
    }
    renderImage() {
        this.renderImagePromise = cancelable(new Promise((resolve, reject) => {
            if (!this.url) {
                reject();
            }
            const pixelRatio = window.devicePixelRatio;
            const sizeWidth = Math.floor(pixelRatio * this.maxDimensions.width);
            const sizeHeight = Math.floor(pixelRatio * this.maxDimensions.height);
            const urlWithSizeParam = replaceParam('size', `${sizeWidth}x${sizeHeight}`, this.url); // add util to get variation
            this.image.onload = () => {
                this.dimensions = { width: this.image.naturalWidth, height: this.image.naturalHeight };
                this.element.appendChild(this.image);
                resolve();
            };
            this.image.onerror = error => {
                reject();
            };
            this.image.src = urlWithSizeParam;
        }));
        return this.renderImagePromise;
    }
    renderPdfCanvas() {
        this.renderPdfCanvasPromise = cancelable(new Promise((resolve, reject) => {
            this.loadPdfPage().then(() => {
                const defaultViewport = this.pdfPage.getViewport({ scale: 1 });
                const pixelRatio = window.devicePixelRatio;
                const scale = (this.maxDimensions.width * pixelRatio) / defaultViewport.width;
                const viewport = defaultViewport.clone({ scale });
                const canvas = (this.canvas = document.createElement('canvas'));
                const context = canvas.getContext('2d', {
                    willReadFrequently: true
                });
                this.dimensions = { width: Math.floor(viewport.width), height: Math.floor(viewport.height) };
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                const renderContext = {
                    canvasContext: context,
                    viewport
                };
                this.renderPdfCanvasTask = this.pdfPage.render(renderContext);
                this.renderPdfCanvasTask.promise
                    .then(() => {
                    this.element.appendChild(this.canvas);
                    resolve();
                })
                    .catch(error => {
                    if (error.type === 'canvas') {
                        console.log('PdfThumbnailViewerPageComponent :: error instanceof RenderingCancelledException');
                        return;
                    }
                    reject();
                });
            }, () => reject());
        }));
        return this.renderPdfCanvasPromise;
    }
    loadPdfPage() {
        this.loadPdfPagePromise = cancelable(new Promise((resolve, reject) => {
            return this.pdfJsService
                .getPage(this.pageNumber)
                .then(pdfPage => {
                this.pdfPage = pdfPage;
                resolve();
            })
                .catch(error => {
                reject();
            });
        }));
        return this.loadPdfPagePromise;
    }
    destroy() {
        if (this.renderImagePromise) {
            this.renderImagePromise.cancel();
            this.renderImagePromise = null;
        }
        if (this.renderPdfCanvasPromise) {
            this.renderPdfCanvasPromise.cancel();
            this.renderPdfCanvasPromise = null;
        }
        if (this.loadPdfPagePromise) {
            this.loadPdfPagePromise.cancel();
            this.loadPdfPagePromise = null;
        }
        if (this.renderPdfCanvasTask) {
            this.renderPdfCanvasTask.cancel();
            this.renderPdfCanvasTask = null;
        }
        this.image.onload = null;
        this.image.onerror = null;
        this.image.src = TRANSPARENT_IMAGE_SRC;
        this.image = null;
        if (this.element.parentElement) {
            this.element.parentElement.removeChild(this.element);
        }
        this.element.innerHTML = '';
    }
}
//# sourceMappingURL=pdf-thumbnail-viewer-page.component.js.map